import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOffline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 32,
	fill: "none",
	viewBox: "0 0 50 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#959595",
		fillRule: "evenodd",
		d: "M36.25 32h-26.2c-13.337 0-13.431-20.702-.094-20.828-2.183-8.27 9.56-13.45 14.472-6.703C33.768-5.058 50 1.606 50 15.423 50 22.41 43.562 32 36.25 32zm-15.118-7.706L25 20.317l3.868 3.977 2.617-2.692-3.867-3.978 3.867-3.977-2.617-2.693L25 14.932l-3.868-3.978-2.618 2.693 3.867 3.977-3.867 3.978 2.618 2.692z",
		clipRule: "evenodd"
	})
});
export default SvgOffline;
